import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';


export const SuccessMsg = ({ msg }) => <div><FontAwesomeIcon className="toastImg" size={'1x'} icon={faCheck} />{msg}</div>;

export const ErrorMsg = ({ msg }) => <div><FontAwesomeIcon className="toastImg" size={'1x'} icon={faExclamationTriangle} />{msg}</div>;